import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import Event from '@app/models/event'
import Logo from '@app/components/shared/Logo'
import StateLabel from '@app/components/shared/StateLabel'

const ProfileSubheader = ({ event, user }) => {
  return (
    <div className="profile-subheader">
      <div className="profile-subheader__wrapper">
        <Link to="/" className="profile-subheader__logo">
          <Logo theme="inherit" event={event}  />
        </Link>
        <div className="profile-subheader__label">
          <StateLabel event={event} />
        </div>
      </div>
    </div>
  )
}

ProfileSubheader.propTypes = {
  event: PropTypes.instanceOf(Event).isRequired
}

export default ProfileSubheader
